module.exports = __webpack_public_path__ + "img/carousel-2.3a1cca5c.png";